import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

const TokenExpirationModal = ({ open, onClose, details }) => {
  const message = details?.message;
  const isInvalidated = typeof message === 'string' && /invalid|revok|refresh/i.test(message);
  const title = isInvalidated ? 'Session Invalidated' : 'Session Expired';
  const body = isInvalidated
    ? 'Your session is no longer valid. Please sign in again to continue.'
    : 'Your session has expired. Please log in again to continue.';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        }
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        pb: 2
      }}>
        <ErrorOutline sx={{ fontSize: 40, color: 'error.main' }} />
        <Typography variant="h5" fontWeight="600">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pl: 7 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
            {body}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#49A0AD',
            textTransform: 'none',
            px: 4,
            '&:hover': {
              backgroundColor: '#3a7a82',
            }
          }}
        >
          OK, Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenExpirationModal;
